import React, { useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

const ProductosSuscripcion = () => {
  const subscriptions = [
    {
      id: "SUB-001",
      name: "Mensual",
      description: "Cuenta para 3 Televisores",
      price: "$10.00",
      status: "Activo",
      purchasedDate: "2024-12-01",
      renewalPeriod: "Mensual",
    },
    {
      id: "SUB-002",
      name: "Anual",
      description: "Cuenta para 3 Televisores",
      price: "$20.00",
      status: "Activo",
      purchasedDate: "2024-11-15",
      renewalPeriod: "Anual",
    },
    {
      id: "SUB-003",
      name: "6 Meses",
      description: "Cuenta para 3 Televisores",
      price: "$5.00",
      status: "Inactivo",
      purchasedDate: "2024-10-10",
      renewalPeriod: "6 Meses",
    },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);

  const openModal = (subscription) => {
    setModalData(subscription);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalData(null);
  };

  const calculateRenewalDate = (purchasedDate, period) => {
    const date = new Date(purchasedDate);
    switch (period) {
      case "Mensual":
        date.setMonth(date.getMonth() + 1);
        break;
      case "Anual":
        date.setFullYear(date.getFullYear() + 1);
        break;
      case "6 Meses":
        date.setMonth(date.getMonth() + 6);
        break;
      default:
        return "No aplica";
    }
    return date;
  };

  const calculateDaysLeft = (renewalDate) => {
    const today = new Date();
    const diffTime = renewalDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays : 0;
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Productos de Suscripción</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {subscriptions.map((subscription) => {
          const renewalDate = calculateRenewalDate(
            subscription.purchasedDate,
            subscription.renewalPeriod
          );
          const daysLeft = calculateDaysLeft(renewalDate);

          return (
            <div
              key={subscription.id}
              className="p-4 bg-white rounded-lg shadow border border-gray-200 relative"
            >
              <div className="absolute top-2 right-2">
                {subscription.status === "Activo" ? (
                  <span className="bg-green-100 text-green-700 text-xs font-bold px-2 py-1 rounded-full">
                    Activo
                  </span>
                ) : (
                  <span className="bg-red-100 text-red-700 text-xs font-bold px-2 py-1 rounded-full">
                    Inactivo
                  </span>
                )}
              </div>
              <h3 className="text-lg font-bold mb-2">{subscription.name}</h3>
              <p className="text-gray-600 text-sm mb-2">
                {subscription.description}
              </p>
              <p className="text-gray-700 font-semibold mb-2">
                Precio: {subscription.price}
              </p>
              <p className="text-gray-500 text-sm">
                Comprado: {subscription.purchasedDate}
              </p>
              {subscription.status === "Activo" && (
                <div>
                  <p className="text-gray-500 text-sm">
                    Próxima renovación: {renewalDate.toISOString().split("T")[0]}
                  </p>
                  <p className="text-gray-500 text-sm">
                    Días restantes: {daysLeft} días
                  </p>
                </div>
              )}
              <button
                onClick={() => openModal(subscription)}
                className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
              >
                Gestionar producto
              </button>
            </div>
          );
        })}
      </div>

      {/* Modal Dialog */}
      <Transition appear show={isModalOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    Acciones de Gestión
                  </Dialog.Title>
                  <div className="mt-4 space-y-4">
                    <div className="p-4 bg-gray-50 border border-gray-300 rounded-md">
                      <h4 className="font-bold text-gray-700">Detalles del Servicio</h4>
                      <p className="text-sm text-gray-600">
                        Usuario Flujo TV: HVLorenzoPi
                      </p>
                      <p className="text-sm text-gray-600">Clave: 3246f3256</p>
                      <p className="text-sm text-gray-600">
                        Fecha de finalización: 22/02/2025
                      </p>
                    </div>
                    <div className="p-4 bg-gray-50 border border-gray-300 rounded-md">
                      <h4 className="font-bold text-gray-700">Agregar Saldo</h4>
                      <p className="text-sm text-gray-600">
                        Agrega más saldo para extender tu plan.
                      </p>
                      <button className="mt-2 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600">
                        Agregar Saldo
                      </button>
                    </div>
                    <div className="p-4 bg-gray-50 border border-gray-300 rounded-md">
                      <h4 className="font-bold text-gray-700">Eliminar Cuenta</h4>
                      <p className="text-sm text-gray-600">
                        Elimina tu cuenta de manera permanente.
                      </p>
                      <button className="mt-2 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600">
                        Eliminar Cuenta
                      </button>
                    </div>
                  </div>
                  <div className="mt-6 flex justify-end">
                    <button
                      type="button"
                      className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
                      onClick={closeModal}
                    >
                      Cerrar
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default ProductosSuscripcion;
